import { object, boolean, InferType } from 'yup';

import { damageReportFieldNames } from 'src/pages/DamageReportPage/constants';

export const accidentBreakdownSchema = object({
  [damageReportFieldNames.isAccident]: boolean().required().nullable(),
});

export type AccidentBreakdownSchemaType = InferType<typeof accidentBreakdownSchema>;
